/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetAsReadyForCloseModel as DigiworkMaitreDPosDtoOrderSetAsReadyForCloseModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Order/set-as-ready-for-close-model';

export interface SetOrderBillAsReadyForClose$Params {
      body?: DigiworkMaitreDPosDtoOrderSetAsReadyForCloseModel
}

export function setOrderBillAsReadyForClose(http: HttpClient, rootUrl: string, params?: SetOrderBillAsReadyForClose$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, setOrderBillAsReadyForClose.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

setOrderBillAsReadyForClose.PATH = '/api/wtr/OrderBill/setorderbillasreadyforclose';
